import {BufferAttribute,BufferGeometry,Group,Mesh} from 'three'
import type asset from '../../SourceArt/Wireforms/mesh.json'
import type {PartPalette} from './partsKit'
import type {Vec3} from './tubePath'
let data:typeof asset|undefined
export async function prepareAuthoredWires():Promise<void>{data??=(await import('../../SourceArt/Wireforms/mesh.json')).default}
/** Match the actual solver samples. An edited Builder curve uses the procedural fallback. */
export function addAuthoredWire(machine:string,id:string,path:readonly Vec3[],group:Group,palette:PartPalette,geometries:BufferGeometry[]):boolean {
 const row=data?.ramps.find(r=>r.machineId===machine&&r.layerId===id)
 if(!row||row.path.length!==path.length||!path.every((p,i)=>p.every((n,j)=>Math.abs(n-row.path[i]![j]!)<=1e-8)))return false
 for(const p of row.parts){
  const g=new BufferGeometry();g.setAttribute('position',new BufferAttribute(new Float32Array(p.positions),3));g.setAttribute('normal',new BufferAttribute(new Float32Array(p.normals),3));g.setAttribute('uv',new BufferAttribute(new Float32Array(p.uvs),2));g.setIndex(p.triangles);g.computeBoundingBox();g.computeBoundingSphere();geometries.push(g)
  const mesh=new Mesh(g,palette.get('wire'));mesh.name=id+'.authored.Wire';group.add(mesh)
 }
 return true
}
